import { Chip } from "@mui/material";
import React, { useMemo } from "react";

import { FaxProfileStatus } from "hooks/useFaxProfile";
import { useCelleraTheme } from "theme/useCelleraTheme";

interface FaxStatusBadgeProps {
  status: FaxProfileStatus;
}

const FaxStatusBadge: React.FC<FaxStatusBadgeProps> = ({ status }) => {
  const { colors } = useCelleraTheme();

  const palette: Record<
    FaxProfileStatus,
    { background: string; foreground: string; label: string }
  > = useMemo(
    () => ({
      active: {
        background: colors.success[100],
        foreground: colors.success[700],
        label: "ACTIVE",
      },
      suspended: {
        background: colors.warning[100],
        foreground: colors.warning[700],
        label: "SUSPENDED",
      },
      retired: {
        background: colors.border.light,
        foreground: colors.text.secondary,
        label: "RETIRED",
      },
      draft: {
        background: colors.warning[100],
        foreground: colors.warning[700],
        label: "DRAFT",
      },
    }),
    [colors],
  );

  const tone = palette[status];

  return (
    <Chip
      label={tone.label}
      aria-label={`Fax profile status: ${status}`}
      sx={{
        backgroundColor: tone.background,
        color: tone.foreground,
        border: `1px solid ${tone.foreground}`,
        fontWeight: 600,
        fontSize: "0.75rem",
        height: 24,
        borderRadius: 0,
      }}
    />
  );
};

export default FaxStatusBadge;
